import ApiService from '@/services/api.service'
import type {
  UserResponse,
  LoginCredentials,
  LoginResponse,
  RefreshTokenResponse,
  LogoutResponse,
  UpdatePassword,
  ForgotPasswordForm,
  ForgotPasswordResponse,
  verifyEmailResponse,
} from '@/types'

const AuthService = {
  login: (credentials: LoginCredentials) =>
    ApiService().post<LoginResponse>('user/auth/login', credentials),

  register: (credentials: any) =>
    ApiService().post<LoginResponse>('/user/register', credentials),

  getMe: () => ApiService().get<UserResponse>('user/auth/user'),

  logout: () => ApiService().post<LogoutResponse>('user/auth/logout'),

  refresh: () => ApiService().post<RefreshTokenResponse>('user/auth/refresh'),

  updatePassword: (data: UpdatePassword) =>
    ApiService().put<UserResponse>('user/auth/me/update-password', data),

  forgot: (form: ForgotPasswordForm) =>
    ApiService().post<ForgotPasswordResponse>(`user/auth/forgot-password`, form),

  verifyEmail: (form: ForgotPasswordForm) =>
    ApiService().post<verifyEmailResponse>(`user/auth/reset/verify-otp`, form),

  resendVerification: () => 
    ApiService().post('user/auth/email/verification-notification'),

  resetPassword: (form: ForgotPasswordForm) =>
    ApiService().post<ForgotPasswordResponse>(`user/auth/reset-password`, form),
}

export default AuthService